import Swiper, {Navigation, Lazy} from "swiper";
import {LG_WIDTH} from "@main/helpers/const";

class MagazinesSlider {
    constructor(el) {
        this.el = el;
        this.autoWidth = document.body.classList.contains("special_version");
        this.createMagazinesSlider();
    }

    createMagazinesSlider() {
        new Swiper(this.el, {
            modules: [Navigation, Lazy],
            slidesPerView: "auto",
            preloadImages: false,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 2,
            },
            watchSlidesProgress: true,
            spaceBetween: 8,
            breakpoints: {
                [LG_WIDTH]: {
                    spaceBetween: 16,
                }
            },
            navigation: {
                nextEl: ".js-magazines-next",
                prevEl: ".js-magazines-prev"
            }
        });
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-magazines-slider")
        .forEach(slider => new MagazinesSlider(slider));
});
